var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftHalf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pizzatoppings",
    transform: "translate(-63.000000, -154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT-Copy",
    transform: "translate(64.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#774518",
    strokeWidth: 2,
    fill: "#B93131",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,4 L14,26 C7.92486775,26 3,21.0751322 3,15 C3,8.92486775 7.92486775,4 14,4 Z",
    id: "Combined-Shape",
    fill: "#CBCBCB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftHalf);
export default __webpack_public_path__ + "static/media/LeftHalf.861d8a02a88252a8db97228b38492ddf.svg";
export { ForwardRef as ReactComponent };